<div class="featured-products" *ngIf="featuredProducts?.length > 0">
  <p class="menu-title">{{ 'FEATURED_PRODUCTS' | translate }}:</p>
  <ion-slides tappable [options]="slideOpts" pager="false">
    <ion-slide class="slide" *ngFor="let product of featuredProducts">
      <featured-product [item]="product" [firm]="firm"></featured-product>
    </ion-slide>
  </ion-slides>
</div>
